export const environment = {
    appName: "ABHARAN_SCHEME_ADMIN",
    production: false,
    apiUrl: 'https://scheme-devapi.abharan.com/',
    apiPrefix: 'api/v1',
    media_domain: 'https://d2hazhkwxu3du8.cloudfront.net/scheme-app/development'
};
